import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { HeaderClickItem } from "@faire/retailer-visitor-shared/components/Header/HeaderClickItem";
import { NotificationBellWithStreaks } from "@faire/retailer-visitor-shared/components/Header/HeaderNotifications/__internal__/NotificationBellWithStreaks";
import { useHasHighPriorityNotification } from "@faire/retailer-visitor-shared/components/Header/HeaderNotifications/__internal__/NotificationDropdown/hooks/useHasHighPriorityNotification";
import { useHasUnreadNotification } from "@faire/retailer-visitor-shared/components/Header/HeaderNotifications/__internal__/NotificationDropdown/hooks/useHasUnreadNotification";
import { useShouldPerformHighPriorityAction } from "@faire/retailer-visitor-shared/components/Header/HeaderNotifications/__internal__/NotificationDropdown/hooks/useShouldPerformHighPriorityAction";
import { LazyNotificationDropdown } from "@faire/retailer-visitor-shared/components/Header/HeaderNotifications/__internal__/NotificationDropdown/index";
import { ANIMATION_TIME } from "@faire/retailer-visitor-shared/components/Header/HeaderNotifications/consts";
import { useIsOnNotificationsPage } from "@faire/retailer-visitor-shared/components/Header/HeaderNotifications/hooks/useIsOnNotificationsPage";
import { useNotificationPreview } from "@faire/retailer-visitor-shared/components/Header/HeaderNotifications/hooks/useNotificationPreview";
import { useSetNotificationState } from "@faire/retailer-visitor-shared/components/Header/HeaderNotifications/hooks/useSetNotificationState";
import { IconWithMaybeDot } from "@faire/retailer-visitor-shared/components/Header/icons/IconWithMaybeDot";
import { HeaderDropdown, HeaderIconContainer, MAX_HEADER_WIDTH } from "@faire/retailer-visitor-shared/components/Header/styled";
import { useHeaderPriorityStore } from "@faire/retailer-visitor-shared/components/HeaderPriorityRenderer/HeaderPriorityPriovider";
import { useIsHeaderDropdownVisible } from "@faire/retailer-visitor-shared/components/HeaderPriorityRenderer/useIsHeaderDropdownVisible";
import { useRetailer } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailer";
import { debounceIfPossible } from "@faire/web--source/common/globals/debounceIfPossible";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { Spacer } from "@faire/web--source/slate/spacing";
import { useDelayedCallback } from "@faire/web--source/ui/hooks/useDelayedCallback";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { useViewportWidth } from "@faire/web--source/ui/hooks/useViewportWidth";
import { useInvalidateQuery as useInvalidateGetNotificationQuery } from "@faire/web-api--source/api/retailer/notifications/get-hooks";
import { trackRetailerNotificationsNotificationBellClick } from "@faire/web-api--source/events/retailerNotifications/click/notificationBell";
import notificationsPage from "@faire/web-api--source/routes/user/notifications";
import isUndefined from "lodash/isUndefined";
import React, { Suspense, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
export var HeaderNotificationsDropdown = function() {
    var history = useHistory();
    var isMobile = useViewport().isMobile;
    var isSSR = useIsSSR();
    var _useRetailer = useRetailer(), retailer = _useRetailer.retailer, retailerToken = _useRetailer.retailerToken;
    var hasHighPriorityNotification = useHasHighPriorityNotification();
    var hasUnreadNotification = useHasUnreadNotification().hasUnreadNotification;
    var isOnNotificationsPage = useIsOnNotificationsPage();
    var _useState = _sliced_to_array(useState(false), 2), shouldShowDropdown = _useState[0], setShouldShowDropdown = _useState[1];
    var _useState1 = _sliced_to_array(useState(hasUnreadNotification), 2), shouldShowNotificationDot = _useState1[0], setShouldShowNotificationDot = _useState1[1];
    var notificationPreview = useNotificationPreview();
    var _notificationPreview_token;
    var setNudgeHasBeenDismissed = useSetNotificationState((_notificationPreview_token = notificationPreview === null || notificationPreview === void 0 ? void 0 : notificationPreview.token) !== null && _notificationPreview_token !== void 0 ? _notificationPreview_token : "").setNudgeHasBeenDismissed;
    var invalidateGetNotificationQuery = useInvalidateGetNotificationQuery();
    var _useHeaderPriorityStore = _sliced_to_array(useHeaderPriorityStore([
        "isNotificationPreviewVisible"
    ]), 1), isNotificationPreviewVisible = _useHeaderPriorityStore[0].isNotificationPreviewVisible;
    var shouldPerformHighPriorityAction = useShouldPerformHighPriorityAction();
    var setHeaderDropdownVisibility = useIsHeaderDropdownVisible().setHeaderDropdownVisibility;
    var viewportWidth = useViewportWidth(function(width) {
        return width;
    });
    // place the dropdown at the right edge of the header
    var rightPosition = viewportWidth <= MAX_HEADER_WIDTH ? 0 : (viewportWidth - MAX_HEADER_WIDTH) / 2;
    useEffect(function() {
        setShouldShowNotificationDot(hasUnreadNotification);
    }, [
        hasUnreadNotification
    ]);
    useEffect(function() {
        if (isOnNotificationsPage) {
            setShouldShowNotificationDot(false);
        }
    }, [
        isOnNotificationsPage
    ]);
    var delayedShowDropdown = useDelayedCallback(function() {
        setShouldShowDropdown(true);
    });
    var toggleDropdownHandler = function(shouldShowDropdown, isOutsideClick) {
        if (hasUnreadNotification && !shouldShowDropdown && !isOutsideClick) {
            // Invalidate query if there was an unread notification and the dropdown was closed
            invalidateGetNotificationQuery();
        }
        if (hasUnreadNotification && shouldShowDropdown) {
            setShouldShowNotificationDot(false);
        }
        if (isNotificationPreviewVisible && shouldShowDropdown && !isOutsideClick) {
            delayedShowDropdown(ANIMATION_TIME);
        } else {
            setShouldShowDropdown(shouldShowDropdown);
        }
        setHeaderDropdownVisibility("NOTIFICATIONS", shouldShowDropdown);
    };
    var gotoNotificationPage = debounceIfPossible(function() {
        history.push(notificationsPage());
    });
    var handleClick = function() {
        if (isMobile && !isOnNotificationsPage) {
            gotoNotificationPage();
        }
        trackRetailerNotificationsNotificationBellClick(retailerToken !== null && retailerToken !== void 0 ? retailerToken : "");
        if (hasHighPriorityNotification && notificationPreview && isUndefined(notificationPreview === null || notificationPreview === void 0 ? void 0 : notificationPreview.nudge_dismissed_at)) {
            setNudgeHasBeenDismissed();
        }
    };
    if (retailer === undefined) {
        return null;
    }
    var shouldRenderDropdown = !isMobile;
    var shouldRenderNotificationDot = !isSSR && (hasUnreadNotification && shouldShowNotificationDot && !isNotificationPreviewVisible && !hasHighPriorityNotification || shouldPerformHighPriorityAction);
    var notificationDropdown = !shouldRenderDropdown ? null : /*#__PURE__*/ _jsx(HeaderDropdown, {
        $right: "".concat(rightPosition, "px"),
        $width: "392px",
        $maxHeight: "calc(100vh - 110px)",
        children: /*#__PURE__*/ _jsx(Suspense, {
            fallback: null,
            children: /*#__PURE__*/ _jsx(LazyNotificationDropdown, {
                hideDropdown: function() {
                    return setShouldShowDropdown(false);
                }
            })
        })
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Spacer, {
                width: 12
            }),
            /*#__PURE__*/ _jsx(HeaderClickItem, {
                clickChild: notificationDropdown,
                dataTestId: "notificationDropdown",
                toggleDropdown: function(shouldShowDropdown, isOutsideClick) {
                    return toggleDropdownHandler(shouldShowDropdown, isOutsideClick);
                },
                shouldShowDropdown: shouldShowDropdown,
                shouldDisableClick: !shouldRenderDropdown,
                onClick: handleClick,
                children: /*#__PURE__*/ _jsx(HeaderIconContainer, {
                    children: /*#__PURE__*/ _jsx(IconWithMaybeDot, {
                        icon: /*#__PURE__*/ _jsx(NotificationBellWithStreaks, {
                            shouldAnimate: shouldPerformHighPriorityAction,
                            delayAnimationTime: shouldPerformHighPriorityAction ? 1250 : 2000
                        }),
                        hasHighPriority: hasHighPriorityNotification,
                        shouldAnimateDot: shouldRenderNotificationDot,
                        dataTestId: "unread-notification-dot",
                        shouldShowDot: shouldRenderNotificationDot,
                        isActive: shouldShowDropdown && !isMobile,
                        delayAnimationTime: shouldPerformHighPriorityAction ? 0 : 750
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                width: {
                    mobileAndAbove: 0,
                    desktopAndAbove: "2x"
                }
            })
        ]
    });
};
